<template>
    <h3 v-if="titol" class="my-2 text-base  text-left text-red-600 max-w-screen-lg lg:mx-auto mx-2 bg-white drop-shadow rounded-sm p-1 px-2">{{titol + ' ('+filtrarDades().length+'):'}}</h3>
    <div v-if="loading==true" class="flex flex-wrap justify-center mx-auto">
        <div v-for="i in skeleton" :key="i" 
        class="aspect-square bg-gray-300 border-gray-200 border-solid border animate-pulse" 
        :style="{width:mida+'px',height:mida+'px'}"></div>
    </div>
    <div v-else id="mosaic" class="flex flex-wrap justify-center">
        
       <!-- <div :style="{ backgroundImage: `url(${escutsSprite})`, width:mida+'px', height:mida+'px',backgroundPosition:-mida+'px 0px' ,backgroundSize:mida*12+'px'}">
    test test
  </div>-->

        <div
        class="
        group
        relative
        grid flex-col 
        outline-white
        
        z-[500]
        hover:z-[700]
        focus:z-[700]

        hover:outline-gray-200/75
        hover:drop-shadow-md 
        hover:outline-solid 
        hover:outline-[3px] 
        hover:outline 
        
        
        focus:outline-white
        focus:drop-shadow-lg
        focus:outline-solid
        focus:oultine-[3px] 
        focus:outline

        transition"
        :class="colla.color_hsl[2]>=40 ? colla.codi_color=='#fefefe'? 'text-black border border-gray-150':'text-black':'text-white'"

        v-for="(colla,index) in filtrarDades()" 
        :key="index"
        tabindex="0"
        :id="'colla-'+colla.id+'-'+index"
        :style="{ 
            width:mida + 'px',
            height:mida + 'px', 
            backgroundColor: perfilColor(colla),
            ...backgroundStyles(colla)
            }"
        
        :aria-label="`Fes dos clics per anar al perfil de ${colla.nom}`"
        :title="`Fes dos clics per anar al perfil de ${colla.nom}`"
        role="button"
        >
        <!--<img src="../assets/escuts/escuts_sprite.png" style="width:100%" class="overflow-hidden absolute">-->
        <div class="absolute flex flex-col h-full w-full justify-between items-end px-1"
        :class="midaIcones">
        <div v-if="icones_tipus==true" class="">
            <IcoTipEst  :key=colla.id  :colla="colla" dada="tipus" :opacity=40 />
        </div>  
        
        <div v-if="(icones_estat==false&&nomes_desaparegudes==true)&&colla.estat=='desapareguda'" class="h-full flex items-end" 
        >
           <IcoTipEst :key=colla.id  :colla="colla" dada="estat"  :opacity=40 />
        </div>

        <div v-if="icones_estat==true" class="h-full flex items-end" >
           <IcoTipEst :key=colla.id  :colla="colla" dada="estat"  :opacity=40 />
        </div>
        </div>
        <router-link :to="'/' + colla.llista + '/' + colla.id" :title="`Torna a fer clic per anar al perfil de ${colla.nom}`"
        :aria-label="`Torna a fer clic per anar al perfil de ${colla.nom}`"
        class="opacity-60 absolute text-center justify-center items-center text-2xl w-full h-full group-focus:flex group-hover:md:flex hidden p-1">
            <font-awesome-icon :class="mida>=24?'block':'hidden'" :icon="['fas', 'arrow-up-right-from-square']"/>
        </router-link>
        <p class="place-self-center truncate w-full text-center font-bold opacity-80 px-1" 
        v-if="seleccio=='desconeguts'||nom_color==true" 
        :style="{fontSize:(mida/6)+'px'}">
            {{ colla.color_camisa }}
        </p>
            <tippy :key=colla.id to="parent" content-tag="div" content-class="w-fit z-[9999]"> 
                <TargetaPerfil tema="fosc" :colla="colla" class="w-72"/>
            </tippy>
        </div>
    </div>
</template>

<script setup async>
import { inject,computed,defineProps,onMounted,ref } from 'vue'
let loading = ref(true)
onMounted (async()=>{
    setTimeout(() => {
    loading.value = false
  }, 1)
})

//import TargetaInfo from './TargetaInfo.vue'
import TargetaPerfil from './TargetaPerfil.vue'
import IcoTipEst from './IcoTipEst.vue'
const props = defineProps({
            
    llista: {
        type: Array,
        required:true
    },
    titol:{
        type:String,
        required:false
    },
    mida:{
        type: Number,
        default:80
    },
    seleccio:{
        type: String,
        default:"coneguts"
    },
    tipus:{
        type: Array,
        required:false,
        default:()=>['convencional','universitaria','internacional']
    },
    estat:{
        type: Array,
        required:false,
        default:()=>['activa','formacio','desapareguda']

    },
    perfil_color:{
        type:String,
        default:"default",
        required:false
    },
    patrons:{
        type:Boolean,
        default:false,
        required:false
    },
    escuts:{
        type:Boolean,
        default:false,
        required:false
    },
    icones_tipus:{
        type:Boolean,
        default:true,
        required:false
    },
    icones_estat:{
        type:Boolean,
        default:true,
        required:false
    },
    nom_color:{
        type:Boolean,
        default:true,
        required:false
    },
    nomes_desaparegudes:{
        type:Boolean,
        default:true,
        required:false
    },
    filtra:{
        type:Boolean,
        default:true,
        required:false
    },
    skeleton:{
        type:Number, 
        default:100, 
        required:false
    }

})
//icones
const midaIcones = computed(()=>{
        if(props.mida>=60&&props.mida<=120){
            return 'text-lg'
        }
        else if(props.mida>120){
            return 'text-2xl'
        }
        else if(props.mida<60&&props.mida>40){
            return 'text-sm'
        }
        else if(props.mida<40){
            return 'hidden'
        }
        else {
            return 'hidden'
        }
    })

//escuts i patrons
const escutsSprite = inject('escutsSprite')
function backgroundStyles(colla){
    const styles = {}
    if (colla.patro?.length&&props.patrons==true){
        if (colla.xy_escut?.length&&props.escuts==true){
            styles.backgroundImage= `url(${escutsSprite}), url(${require('@/assets/patrons/' + colla.patro[0])})`, 
            styles.backgroundPosition= `${-props.mida*colla.xy_escut[0]}px ${-props.mida*colla.xy_escut[1]}px, center`,
            styles.backgroundSize= `${props.mida * 12}px, ${colla.patro[1]}%`
        }
        else {
            styles.backgroundImage= `url(${require('@/assets/patrons/' + colla.patro[0])})`, 
            styles.backgroundPosition= `center`,
            styles.backgroundSize= `${colla.patro[1]}%`
        }
    }
    else{
        if (colla.xy_escut?.length&&props.escuts==true){
            styles.backgroundImage= `url(${escutsSprite})`, 
            styles.backgroundPosition= `${-props.mida*colla.xy_escut[0]}px ${-props.mida*colla.xy_escut[1]}px`,
            styles.backgroundSize= props.mida*12+'px'
        }
        
    }
    return styles
}
//cerca i dades

function  filtrarDades(){
    if (props.filtra){return  props.llista.filter(colla=>
    
    props.tipus.includes(colla.tipus)&&
    props.estat.includes(colla.estat)
    )}
    else {return props.llista}
}

function perfilColor(colla){
    if (props.perfil_color==="default"){
        return colla.codi_color;
    }
    else if (props.perfil_color==="monocrom"){
        return "hsl(0,0%,"+colla.color_hsl[2]+"%)";
    }
    else if (props.perfil_color==="hsl"){
        return "hsl("+colla.color_hsl[0]+","+colla.color_hsl[1]+"%,"+colla.color_hsl[2]+"%)";
    }
    else{
        return "ffffff"
    }
}
</script>
